export const FirebaseConfig = {
	"projectId": "eztruck-309418",
	"appId": "1:10263549299:web:d63ec34797e53f9e996106",
	"databaseURL": "https://eztruck-309418-default-rtdb.firebaseio.com",
	"storageBucket": "eztruck-309418.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyDRlGM9dp3II-gVoUcGoWRu4nE_vMseAa0",
	"authDomain": "eztruck-309418.firebaseapp.com",
	"messagingSenderId": "10263549299",
	"measurementId": "G-G55LE9H1MT"
};